<div class="footer-container d-flex flex-column gap-4">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <span class="title">SINGAPORE COURTS</span>
    <i class="fal fa-angle-down fa-lg d-block d-sm-none" (click)="onFooterToggle()" (keydown)="handleDropdownKey($event)"
></i>
  </div>
  @if(expanded) {
  <div class="footer-content d-flex gap-5">
     <a class="pb-1" (click)="onNavigateToFAQs()">FAQs</a>
     <a class="pb-1" [href]="footerLinks.contactUs" target="_blank" rel="noopener">Contact Us</a>
  </div>
  <div class="horizontal-divider"></div>
  <div class="footer-content links d-flex gap-5 flex-column flex-sm-row">
     <a class="pb-1" [href]="footerLinks.reportVulnerability" target="_blank" rel="noopener">
     Report Vulnerability <i class="fa-solid fa-up-right-from-square i-color ms-1"></i>
     </a>
     <a class="pb-1" (click)="onNavigateToPrivacy()">Privacy Statement</a>
     <a class="pb-1" (click)="onNavigateToTermsOfUse()">Terms of Use</a>
  </div>
  <div class="credits d-flex flex-column gap-1 align-items-end">
     <span>ⓒ 2025 Government of Singapore.</span>
  </div>
  }
</div>
